type UseScreenSize = () => boolean;

export const useIsMobile: UseScreenSize = () => {
  const userAgent = navigator?.userAgent;
  return !!userAgent.toLowerCase().match(/iphone|android|mobile/);
};
